import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    width: '100%',
  },

  title: {
    margin: '25px 0px 18px 0px',
    boxSizing: 'border-box',
    paddingBottom: '18px',
    borderBottom: '1px solid #D8DBDF',
    color: '#181819',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  children: {
    padding: '0px 10px',
    boxSizing: 'border-box',
    width: '100%',
  },

  rootLight: {
    width: '100%',
    margin: '50px 0px 20px 0px',
  },

  titleLight: {
    boxSizing: 'border-box',
    paddingBottom: '18px',
    borderBottom: '1px solid #D8DBDF',
    color: '#181819',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  link: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
});

class Title extends React.Component {
  render () {
    const { classes } = this.props;

    return (
      <div className={ this.props.color === "dark" ? classes.root : classes.rootLight} style={this.props.style} {...this.props.other}>
        <div className={ this.props.color === "dark" ? classes.title : classes.titleLight}>{this.props.title}</div>
      </div>
    );
  }
}

Title.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  title: PropTypes.string,
  color: PropTypes.string,
  other: PropTypes.object,
}

PropTypes.defaultValue = {}

export default withStyles(styles)(Title);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/ExecDetailItemDialog/common/Title.jsx